module.exports = __webpack_public_path__ + "static/media/FREEDOM-CONTROL.02f7572a.png";